
<div :class="jel_getClassObject(content)">
  <div
    class="entete d-flex justify-content-between align-items-center mx-n2"
    :class="{ 'entete-sans-titre': !content.titre }"
  >
    <div class="d-flex align-items-center retourLien px-2 py-0">
      <Hyperlien
        :content="{
          texte: content.titre,
          type: 'd-inline-flex lienTertiaire graphik_semibold',
          lien: content.titre
            ? {
                ...content.lien,
                nomIcone: 'fleche-droite-mini-lien',
                positionImage: 'gauche',
                cssIcone: 'rotation180',
              }
            : { field: 'aucunLien' },
        }"
      >
      </Hyperlien>
    </div>
    <!-- TODO: Bouton recherche à implémenter (hors-portée) -->
    <!-- <b-link href="#" class="p-2"><b-icon icon="search" scale="0.9"></b-icon></b-link> -->
  </div>
  <Menu :content="contentMenu">
    <template #element="{ itemElement }">
      <div class="d-flex flex-row pt-2">
        <b-img-lazy
          v-if="itemElement.image"
          class="mr-2"
          :src="jel_getFichierSrc(itemElement.image)"
        />
        <div
          :class="
            itemElement.lien.field === 'aucunLien'
              ? itemElement['@name'] == 'listeItems0'
                ? 'graphik_bold body-2 pt-1'
                : 'graphik_bold body-2 pt-2'
              : itemElement.lien.field === 'body-3'
          "
        >
          {{ itemElement.item }}
        </div>
        <b-icon
          v-if="itemElement.lien.field !== 'aucunLien'"
          scale="0.7"
          icon="chevron-right"
          class="ml-auto mr-0"
        ></b-icon>
      </div>
    </template>
  </Menu>
</div>
